// import React, { useEffect, useMemo } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import KeyCompetitorTableComponent from "../../TableComponents/keyCompetitorTableComponent";
// import { fetchCompetitorsRequest } from "../../../store/features/actions/competitorActions";
// import GenericTableSkeleton from "../skeletons/tableSkeleton/genericTableSkeleton";

// export default function KeyCompetitorsTable({ ticker, active_tab_key }) {
//   const { accountId, accountName, clientName } = useParams();
//   const { account_info } = useSelector((state) => state?.accountsReducer);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const USE_DUMMY_DATA = true;

//   const dummyItems = {
//     competitors: [
//       {
//         _id: "c1",
//         data: [
//           { type: "IQ_TOTAL_REV", value: 1200 },
//           { type: "IQ_GP", value: 600 },
//           { type: "IQ_EBITDA", value: 300 },
//           { type: "IQ_EBIT", value: 250 },
//           { type: "IQ_NI", value: 180 },
//           { type: "IQ_BASIC_EPS_INCL", value: 2.5 },
//           { type: "IQ_TOTAL_ASSETS", value: 5000 },
//         ],
//       },
//       {
//         _id: "c2",
//         data: [
//           { type: "IQ_TOTAL_REV", value: 900 },
//           { type: "IQ_GP", value: 430 },
//           { type: "IQ_EBITDA", value: 220 },
//           { type: "IQ_EBIT", value: 180 },
//           { type: "IQ_NI", value: 110 },
//           { type: "IQ_BASIC_EPS_INCL", value: 1.8 },
//           { type: "IQ_TOTAL_ASSETS", value: 4000 },
//         ],
//       },
//     ],
//     companies: {
//       c1: "Competitor A",
//       c2: "Competitor B",
//     },
//   };

//   // Redux state management
//   // const { items, loading, error } = useSelector(
//   //   (state) => state.competitorsReducer
//   // );
//   // const competitors = items?.competitors || [];
//   // const companies = items?.companies || {};

//   const {
//     items: apiItems,
//     loading,
//     error,
//   } = useSelector((state) => state.competitorsReducer);

//   const items = USE_DUMMY_DATA ? dummyItems : apiItems;
//   const competitors = items?.competitors || [];
//   const companies = items?.companies || {};

//   // Column configuration
//   const baseColumnTypes = useMemo(
//     () =>
//       clientName === "Automation Edge"
//         ? [
//             "IQ_TOTAL_CAP",
//             "IQ_TOTAL_REV",
//             "IQ_GP",
//             "IQ_NI",
//             "IQ_BASIC_EPS_INCL",
//             "IQ_TOTAL_ASSETS",
//           ]
//         : [
//             "IQ_TOTAL_CAP",
//             "IQ_TOTAL_REV",
//             "IQ_GP",
//             "IQ_EBITDA",
//             "IQ_EBIT",
//             "IQ_NI",
//             "IQ_BASIC_EPS_INCL",
//             "IQ_TOTAL_ASSETS",
//           ],
//     [clientName]
//   );

//   // Filter columns with valid data
//   const filteredColumnTypes = useMemo(() => {
//     if (!competitors.length) return [];

//     return baseColumnTypes
//       .filter((type) =>
//         competitors.some((competitor) =>
//           competitor.data?.some(
//             (obj) =>
//               obj?.type === type &&
//               obj?.value &&
//               obj.value !== "N/A" &&
//               obj.value !== "Data Unavailable"
//           )
//         )
//       )
//       .filter((type) => type !== "IQ_TOTAL_CAP");
//   }, [baseColumnTypes, competitors]);

//   // Data fetching
//   // useEffect(() => {
//   //   if (ticker) {
//   //     dispatch(fetchCompetitorsRequest(ticker));
//   //   }
//   // }, [ticker, dispatch]);

//   useEffect(() => {
//     if (!USE_DUMMY_DATA && ticker) {
//       dispatch(fetchCompetitorsRequest(ticker));
//     }
//   }, [ticker, dispatch]);

//   // Scroll handling
//   useEffect(() => {
//     if (active_tab_key !== "overview") {
//       window.scrollTo({ top: 0, behavior: "smooth" });
//     }
//   }, [active_tab_key]);

//   // Navigation handler
//   const handleViewMoreCompetitorInsightsLink = (e) => {
//     e.preventDefault();
//     navigate(
//       `/account_details/${accountId}/${accountName}/${clientName}/?tab=more&?subTab=competitor_insights`
//     );
//   };

//   // Loading and error states
//   if (loading) return <GenericTableSkeleton rowCount={10} colCount={8} />;

//   if (!items?.competitors) return null;

//   return (
//     <div className="custom_card_block px-4 py-4">
//       <>
//         <div className="keycomp_new_wrapper mb-2">
//           <div className="Key_competitiors_headblock">
//             <h5 className="Key_competitiors_head">
//               {clientName} vs Key Competitors - Financial Comparison
//               {/* {items?.year && <>({items?.year})</>}  */}
//             </h5>
//             <span className="fig_caption">
//               (Figures in $ Mn, except EPS)
//               {active_tab_key === "overview" && (
//                 <>
//                   <span className="divider">|</span>
//                   <span>
//                     <Link
//                       onClick={handleViewMoreCompetitorInsightsLink}
//                       className="custom_view_all"
//                     >
//                       View All
//                     </Link>
//                   </span>
//                 </>
//               )}
//             </span>
//           </div>
//         </div>

//         {!items?.companies ? null : (
//           <KeyCompetitorTableComponent
//             clientName={clientName}
//             companies={companies}
//             columnTypes={filteredColumnTypes}
//             competitors={competitors}
//           />
//         )}
//       </>
//     </div>
//   );
// }

import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import KeyCompetitorTableComponent from "../../TableComponents/keyCompetitorTableComponent";
import { fetchCompetitorsRequest } from "../../../store/features/actions/competitorActions";
import GenericTableSkeleton from "../skeletons/tableSkeleton/genericTableSkeleton";

export default function KeyCompetitorsTable({ ticker, active_tab_key }) {
  const { accountId, accountName, clientName } = useParams();
  const { account_info } = useSelector((state) => state?.accountsReducer);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // ---------- TOGGLE ----------
  const USE_DUMMY_DATA = true; // set false when API is ready

  // ---------- DUMMY DATA ----------
  // const dummyItems = {
  //   competitors: [
  //     {
  //       _id: "c1",
  //       data: [
  //         { type: "IQ_TOTAL_CAP", value: 51200 },
  //         { type: "IQ_TOTAL_REV", value: 51200 },
  //         { type: "IQ_GP", value: 6000 },
  //         { type: "IQ_EBITDA", value: 3000 },
  //         { type: "IQ_EBIT", value: 2500 },
  //         { type: "IQ_NI", value: 1800 },
  //         { type: "IQ_BASIC_EPS_INCL", value: 25.0 },
  //         { type: "IQ_TOTAL_ASSETS", value: 5000 },
  //       ],
  //     },
  //     {
  //       _id: "c2",
  //       data: [
  //         { type: "IQ_TOTAL_CAP", value: 900 },
  //         { type: "IQ_TOTAL_REV", value: 900 },
  //         { type: "IQ_GP", value: 430 },
  //         { type: "IQ_EBITDA", value: 220 },
  //         { type: "IQ_EBIT", value: 180 },
  //         { type: "IQ_NI", value: 110 },
  //         { type: "IQ_BASIC_EPS_INCL", value: 1.8 },
  //         { type: "IQ_TOTAL_ASSETS", value: 4000 },
  //       ],
  //     },
  //     {
  //       _id: "c3",
  //       data: [
  //         { type: "IQ_TOTAL_CAP", value: 500 },
  //         { type: "IQ_TOTAL_REV", value: 450 },
  //         { type: "IQ_GP", value: 230 },
  //         { type: "IQ_EBITDA", value: 120 },
  //         { type: "IQ_EBIT", value: 110 },
  //         { type: "IQ_NI", value: 90 },
  //         { type: "IQ_BASIC_EPS_INCL", value: 0.8 },
  //         { type: "IQ_TOTAL_ASSETS", value: 1700 },
  //       ],
  //     },
  //   ],
  //   companies: {
  //     c1: "Competitor A",
  //     c2: "Competitor B",
  //     c3: "Competitor C",
  //   },
  // };

  const dummyItems = {
    competitors: [
      {
        _id: "c1",
        data: [
          { type: "IQ_TOTAL_REV", value: 120 },
          { type: "IQ_GP", value: 41 },
          { type: "IQ_EBITDA", value: 25 },
          { type: "IQ_EBIT", value: 18 },
          { type: "IQ_NI", value: 10 },
          { type: "IQ_BASIC_EPS_INCL", value: 3.5 },
          { type: "IQ_TOTAL_ASSETS", value: 500 },
        ],
      },
      {
        _id: "c2",
        data: [
          { type: "IQ_TOTAL_REV", value: 95 },
          { type: "IQ_GP", value: 38 },
          { type: "IQ_EBITDA", value: 18 },
          { type: "IQ_EBIT", value: 12 },
          { type: "IQ_NI", value: 7 },
          { type: "IQ_BASIC_EPS_INCL", value: 2.9 },
          { type: "IQ_TOTAL_ASSETS", value: 460 },
        ],
      },
      {
        _id: "c3",
        data: [
          { type: "IQ_TOTAL_REV", value: 135 },
          { type: "IQ_GP", value: 52 },
          { type: "IQ_EBITDA", value: 30 },
          { type: "IQ_EBIT", value: 22 },
          { type: "IQ_NI", value: 14 },
          { type: "IQ_BASIC_EPS_INCL", value: 4.2 },
          { type: "IQ_TOTAL_ASSETS", value: 610 },
        ],
      },
      {
        _id: "c4",
        data: [
          { type: "IQ_TOTAL_REV", value: 110 },
          { type: "IQ_GP", value: 41 },
          { type: "IQ_EBITDA", value: 22 },
          { type: "IQ_EBIT", value: 17 },
          { type: "IQ_NI", value: 9 },
          { type: "IQ_BASIC_EPS_INCL", value: 3.1 },
          { type: "IQ_TOTAL_ASSETS", value: 480 },
        ],
      },
      {
        _id: "c5",
        data: [
          { type: "IQ_TOTAL_REV", value: 49 },
          { type: "IQ_GP", value: 39 },
          { type: "IQ_EBITDA", value: 11 },
          { type: "IQ_EBIT", value: 9 },
          { type: "IQ_NI", value: 4 },
          { type: "IQ_BASIC_EPS_INCL", value: 1.1 },
          { type: "IQ_TOTAL_ASSETS", value: 155 },
        ],
      },
    ],

    companies: {
      c1: "Competitor A",
      c2: "Competitor B",
      c3: "Competitor C",
      c4: "Competitor D",
      c5: "Competitor E",
    },
  };

  // ---------- API or Dummy Toggle ----------
  const {
    items: apiItems,
    loading,
    error,
  } = useSelector((state) => state.competitorsReducer);
  const items = USE_DUMMY_DATA ? dummyItems : apiItems;

  const competitors = items?.competitors || [];
  console.log("Financial data:", competitors);
  const companies = items?.companies || {};

  // ---------- Base Columns ----------
  const baseColumnTypes = useMemo(
    () =>
      clientName === "Automation Edge"
        ? [
            "IQ_TOTAL_CAP",
            "IQ_TOTAL_REV",
            "IQ_GP",
            "IQ_NI",
            "IQ_BASIC_EPS_INCL",
            "IQ_TOTAL_ASSETS",
          ]
        : [
            "IQ_TOTAL_CAP",
            "IQ_TOTAL_REV",
            "IQ_GP",
            "IQ_EBITDA",
            "IQ_EBIT",
            "IQ_NI",
            "IQ_BASIC_EPS_INCL",
            "IQ_TOTAL_ASSETS",
          ],
    [clientName]
  );

  // ---------- Filter Columns ----------
  const filteredColumnTypes = useMemo(() => {
    if (!competitors.length) return [];

    return baseColumnTypes
      .filter((type) =>
        competitors.some((competitor) =>
          competitor.data?.some(
            (obj) =>
              obj?.type === type &&
              obj?.value &&
              obj.value !== "N/A" &&
              obj.value !== "Data Unavailable"
          )
        )
      )
      .filter((type) => type !== "IQ_TOTAL_CAP");
  }, [baseColumnTypes, competitors]);

  // ---------- API Call (disabled when using dummy) ----------
  useEffect(() => {
    if (!USE_DUMMY_DATA && ticker) {
      dispatch(fetchCompetitorsRequest(ticker));
    }
  }, [ticker, dispatch]);

  // ---------- Scroll ----------
  useEffect(() => {
    if (active_tab_key !== "overview") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [active_tab_key]);

  // ---------- Navigate ----------
  const handleViewMoreCompetitorInsightsLink = (e) => {
    e.preventDefault();
    navigate(
      `/account_details/${accountId}/${accountName}/${clientName}/?tab=more&?subTab=competitor_insights`
    );
  };

  // ---------- Loading ----------
  // if (loading) return <GenericTableSkeleton rowCount={10} colCount={8} />;

  if (!items?.competitors) return null;

  return (
    <div className="custom_card_block px-4 py-4">
      <>
        <div className="keycomp_new_wrapper mb-2">
          <div className="Key_competitiors_headblock">
            <h5 className="Key_competitiors_head">
              {clientName} vs Key Competitors - Financial Comparison
            </h5>

            <span className="fig_caption">
              (Figures in $ Mn, except EPS)
              {active_tab_key === "overview" && (
                <>
                  <span className="divider">|</span>
                  <span>
                    <Link
                      onClick={handleViewMoreCompetitorInsightsLink}
                      className="custom_view_all"
                    >
                      View All
                    </Link>
                  </span>
                </>
              )}
            </span>
          </div>
        </div>

        {items?.companies ? (
          <KeyCompetitorTableComponent
            clientName={clientName}
            companies={companies}
            columnTypes={filteredColumnTypes}
            competitors={competitors}
          />
        ) : null}
      </>
    </div>
  );
}
